import type { FC, ReactNode } from "react";
import type { GameThumbData } from "../GameThumb";
import computeProvider from "../GameThumb/computeProvider";
import type { GameRtpTrend } from "./computeRtpTrend";
import type { GameRtpListVariant } from "./computeVariantStyle";
import GameRtpListBadge from "./GameRtpListBadge";

export type GameRtpListItem = {
  id: string;
  game: GameThumbData;
  thumbnail: ReactNode;
  link: ReactNode;
  providerLink?: ReactNode;
  percentage: string;
  trend?: GameRtpTrend;
};

type Props = {
  item: GameRtpListItem;
  variant: GameRtpListVariant;
};

const GameRtpListRow: FC<Props> = ({ item, variant }) => {
  const provider = computeProvider(item.game);

  return (
    <div
      data-slot="game-rtp-list-row"
      className="relative flex items-center gap-3 rounded-lg p-2 odd:bg-background-secondary"
    >
      <div
        data-slot="game-rtp-list-row-link"
        className="absolute inset-0 [&>a]:absolute [&>a]:inset-0"
      >
        {item.link}
      </div>
      <div className="size-10 shrink-0 overflow-hidden rounded-md [&_img]:size-10 [&_img]:rounded-md [&_img]:object-cover">
        {item.thumbnail}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate font-semibold text-foreground text-sm">
          {item.game.name}
        </p>
        {provider && (
          <p className="relative z-10 truncate text-muted-foreground text-xs">
            {item.providerLink ?? provider.name}
          </p>
        )}
      </div>
      <GameRtpListBadge
        percentage={item.percentage}
        variant={variant}
        trend={item.trend}
      />
    </div>
  );
};

export default GameRtpListRow;
